import { useMemo } from "react";

import sanitizeHtml from "sanitize-html";

const RICH_TEXT_SANITIZE_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: ["p", "br", "strong", "em", "u", "s", "a", "ul", "ol", "li", "span", "sub", "sup"],
  allowedAttributes: {
    a: ["href", "target", "rel"],
    span: ["style"],
  },
  allowedStyles: {
    span: { color: [/^#[0-9a-fA-F]{3,6}$/, /^rgb\(\d{1,3},\s*\d{1,3},\s*\d{1,3}\)$/] },
  },
  allowedSchemes: ["https", "http", "mailto"],
};

export const sanitizeRichTextHtml = (html: string | null | undefined): string | null => {
  if (!html) {
    return null;
  }
  return sanitizeHtml(html, RICH_TEXT_SANITIZE_OPTIONS).trim() || null;
};

export const useSanitizeRichTextHtml = (html: string | null | undefined): string | null => {
  return useMemo(() => sanitizeRichTextHtml(html), [html]);
};
